/**
 * Main cookie consent definition file
 * @description All cookies that will be used in the cookie consent must be defined here. Cookies are grouped by purpose
 * (for example: 'necessary', 'preferences', 'analytic', ...) and defined using 'CookieData' objects. There is a default
 * group named 'necessary' that is used by the app to work with necessary cookies.
 */

import {CookieData} from "../core/dataProtection/objects/cookie";
import {STORAGE_TYPE} from "../core/storage";
import {
	access_token_storage_field_name,
	access_token_storage_type,
	acl_storage_type,
	acl_storage_var, current_user_storage_field_name,
	decoded_access_token_storage_field_name, locale_storage_path,
	locale_storage_type,
	refresh_token_storage_field_name,
	refresh_token_storage_type
} from "../config";

/**
 * Group name for necessary cookies
 * @note This is a reserved group name that will be used to determine which cookies are necessary.
 * @type {string}
 */
const NECESSARY_GROUP_NAME = 'necessary';

/**
 * Necessary cookies
 * @type {CookieData[]}
 */
let necessaryCookies = [
	// App auth
	new CookieData(NECESSARY_GROUP_NAME, access_token_storage_field_name, access_token_storage_type),
	new CookieData(NECESSARY_GROUP_NAME, decoded_access_token_storage_field_name, access_token_storage_type),
	new CookieData(NECESSARY_GROUP_NAME, refresh_token_storage_field_name, refresh_token_storage_type),

	// ACL
	new CookieData(NECESSARY_GROUP_NAME, acl_storage_var, acl_storage_type),
	new CookieData(NECESSARY_GROUP_NAME, current_user_storage_field_name, STORAGE_TYPE.LOCAL),
	new CookieData(NECESSARY_GROUP_NAME, current_user_storage_field_name, STORAGE_TYPE.REDUX),
	
	// Report builder
	new CookieData(NECESSARY_GROUP_NAME, 'builder', STORAGE_TYPE.SESSION),
	new CookieData(NECESSARY_GROUP_NAME, 'builder_select_section_collapsed', STORAGE_TYPE.SESSION),
	new CookieData(NECESSARY_GROUP_NAME, 'builder_filter_section_collapsed', STORAGE_TYPE.SESSION),
];

/**
 * Preference cookies
 * @note These are turned off for.
 * @type {CookieData[]}
 */
let preferenceCookies = [
	// Locale
	new CookieData('preferences', locale_storage_path, locale_storage_type),
	// Skin
	new CookieData('preferences', 'skin_mode', STORAGE_TYPE.LOCAL),
	// Sidebar menu
	new CookieData('preferences', 'sidebar_menu_shrank', STORAGE_TYPE.LOCAL),
];

/**
 * Analytic cookies
 * @type {CookieData[]}
 */
let analyticCookies = [
	
];

/**
 * Marketing cookies
 * @type {CookieData[]}
 */
let marketingCookies = [
	
];

const cookies = [].concat(necessaryCookies, preferenceCookies, analyticCookies, marketingCookies);

export default cookies;